export default __webpack_public_path__ + "static/media/firm-logo-paceholder.28b5cf99.svg";